import {Module} from "@intuitionrobotics/ts-common";
import {XhrHttpModule} from "@intuitionrobotics/thunderstorm/frontend";
import {HttpMethod} from "@intuitionrobotics/thunderstorm";
import {
    Api_CreateContact,
    Api_DeleteAgentUserContact,
    Api_DeleteContact,
    Api_GetFamilyMemberContacts,
    Api_GetUnitContacts,
    Api_HardDeleteContact,
    Api_RequestAgentUserContact,
    Api_SetEmergencyContact,
    Body_SetEmergencyContact,
    CreateContactGeneric_Body,
    DB_Contact,
    DeleteAgentUserContact_Body,
    DeleteContact_Body,
    QueryContacts,
    QueryContactsByPhoneNumber,
    RequestAgentUserContact_Body
} from "@app/ir-q-app-common/types/db-contact";

type Config = {
	websiteUrl: string
}

export const Route_Contacts_Table = "contacts-table";
export const Route_Agent_User_Details = "Agent-user-details";

export class ContactsModule_Class
	extends Module<Config> {

	getMessagingUrl = () => this.config.websiteUrl;
	getContactsTableRoute = () => Route_Contacts_Table;
	getAgentUserDetailsRoute = () => Route_Agent_User_Details

	getContactsPage = () => `${this.getMessagingUrl()}/${this.getContactsTableRoute()}`;
	getUserAgentIframe = () => `${this.getMessagingUrl()}/${this.getAgentUserDetailsRoute()}`;

	createContactAsync(body: CreateContactGeneric_Body<any>): Promise<DB_Contact<any>> {
		return XhrHttpModule
			.createRequest<Api_CreateContact>(HttpMethod.POST, 'BulkCreateContact')
			.setJsonBody(body)
			.setRelativeUrl('/v2/contacts/create')
			.setLabel('Creating contact')
			.executeSync();
	}

	getContactsByPhoneNumber(query: QueryContactsByPhoneNumber): Promise<DB_Contact<any>[]> {
		return XhrHttpModule
			.createRequest<Api_GetFamilyMemberContacts>(HttpMethod.POST, 'BulkGetContactsByPhone')
			.setJsonBody(query)
			.setRelativeUrl('/v2/contacts/get-by-phone-number')
			.setLabel('Querying contacts by phone')
			.executeSync();
	}

	getContactsByUnit(query: QueryContacts): Promise<DB_Contact<any>[]> {
		return XhrHttpModule
			.createRequest<Api_GetUnitContacts>(HttpMethod.POST, 'BulkGetContactsByUnit')
			.setJsonBody(query)
			.setRelativeUrl('/v2/contacts/get-by-unit')
			.setLabel('Querying contacts by unit')
			.executeSync();
	}

	softDeleteContact(body: DeleteContact_Body): Promise<void> {
		return XhrHttpModule
			.createRequest<Api_DeleteContact>(HttpMethod.POST, 'SoftDeleteContact')
			.setJsonBody(body)
			.setRelativeUrl('/v2/contacts/delete')
			.setLabel('Deleting contact')
			.executeSync();
	}

	hardDeleteContact(body: DeleteContact_Body): Promise<void> {
		return XhrHttpModule
			.createRequest<Api_HardDeleteContact>(HttpMethod.POST, 'HardDeleteContact')
			.setJsonBody(body)
			.setRelativeUrl('/v2/contacts/hard-delete')
			.setLabel('Hard deleting contact')
			.executeSync();
	}

	setEmergencyContact(body: Body_SetEmergencyContact): Promise<void> {
		return XhrHttpModule
			.createRequest<Api_SetEmergencyContact>(HttpMethod.POST, 'SetEmergencyContact')
			.setJsonBody(body)
			.setRelativeUrl('/v2/contacts/set-emergency-contact')
			.setLabel('Updating emergency contact')
			.executeSync();
	}

	requestAgentUserContact(body: RequestAgentUserContact_Body): Promise<void> {
		return XhrHttpModule
			.createRequest<Api_RequestAgentUserContact>(HttpMethod.POST, 'RequestAgentUserContact')
			.setJsonBody(body)
			.setRelativeUrl('/v2/contacts/request-agent-user')
			.setLabel('Linking ElliQ user')
			.executeSync();
	}

	deleteAgentUserConnection(body: DeleteAgentUserContact_Body): Promise<void> {
		return XhrHttpModule
			.createRequest<Api_DeleteAgentUserContact>(HttpMethod.POST, 'DeleteAgentUserContact')
			.setJsonBody(body)
			.setRelativeUrl('/v2/contacts/delete-agent-user')
			.setLabel('Unlinking ElliQ user')
			.executeSync();
	}
}

export const ContactsModule = new ContactsModule_Class("ContactsModule");
